import { Box, useMediaQuery, useTheme } from '@mui/material';
import DesktopLayout from './DesktopLayout';
import SharedLayout from './SharedLayout';

const Blank = ({ children, ...props }: { title?: string } & any) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  if (isDesktop) {
    return <DesktopLayout hideAppbar={true} {...props}>{children}</DesktopLayout>;
  }

  return (
    <SharedLayout>
      <Box>
        {children}
      </Box>
    </SharedLayout>
  );
};

export default Blank;